// ===== ENUMS =====
export enum PaymentType {
  FINANCED = 'financed',
  CASH = 'cash',
}

// ===== INTERFACES AUXILIARES =====
export interface IAssetsValue {
  amount: number
  iva: number
  total: number
}

export interface ITerm {
  term: number
  residuary: number
}

export interface IInsuranceDetails {
  startPeriod: Date
  endPeriod: Date
  notifyBeforeExpiry: number
  provider: any
  policyNumber: string
  renewalType: PaymentType
}

export interface IAccessory {
  _id?: string
  name: string
  paymentType: PaymentType
  interestRate?: number
  amount: number
  isInsurance?: boolean
  insuranceDetails?: IInsuranceDetails
}

// ===== INTERFACE PRINCIPAL =====
export interface IQuoteParameters {
  _id?: string
  user: string | any

  // Cliente (definitivo o provisional)
  client?: string | any
  provitionalClient?: string

  // Activos (definitivos o provisionales)
  assets?: string[] | any
  provitionalAsset?: string
  //* Plan v4.3 §7 · Tipo de activo que eligió el cliente (`asset-types.ts`); las cotizaciones viejas no lo traen.
  assetType?: string | null
  provitionalValue?: number
  assetsValue: IAssetsValue

  // Configuración financiera
  leaseType: string
  terms: ITerm[]
  advance: number
  interestRate: number
  openingCommission: number
  advancedRents: number
  ratificationExpenses: number
  // F-016: la escribe el servidor al crear. Con ella la renta anticipada incluye la mensualidad de los accesorios
  // financiados. Solo se reenvía en la vista previa (/calculate); el alta y la edición la rechazan.
  advancedRentsIncludeAccessories?: boolean

  // Accesorios
  accessories: IAccessory[]

  // Metadatos
  createdAt: Date
  updatedAt: Date
  deletedAt?: Date | null
}

// ===== INTERFACES PARA FORMULARIOS =====
export interface ICreateQuoteParameters {
  user: string | any
  client?: string | any
  provitionalClient?: string
  assets?: string[] | any
  provitionalAsset?: string
  provitionalValue?: number
  assetsValue: IAssetsValue
  leaseType: string
  terms: ITerm[]
  advance: number
  interestRate: number
  openingCommission: number
  advancedRents: number
  ratificationExpenses: number
  accessories: IAccessory[]
}

export interface IUpdateQuoteParameters extends Partial<ICreateQuoteParameters> {
  _id: string
}

// ===== INTERFACES PARA RESPUESTAS DEL API =====
export interface IQuoteParametersResponse {
  error: boolean
  message: string
  data: IQuoteParameters
}

export interface IQuoteParametersListResponse {
  error: boolean
  message: string
  data: IQuoteParameters[]
  pagination?: {
    page: number
    limit: number
    total: number
    totalPages: number
  }
}

// ===== INTERFACE PARA LISTA (TABLA) =====
export interface IQuoteParametersList {
  _id?: string
  clientName?: string
  provitionalClient?: string
  assetsCount?: number
  assetsNames?: string
  provitionalAsset?: string
  assetsValue: IAssetsValue
  leaseType: string
  termsCount: number
  advance: number
  interestRate: number
  accessoriesCount: number
  createdAt: Date
  updatedAt: Date
}

// Alias para compatibilidad con el plan original
export interface AccessoryInterface extends IAccessory {}
